<template>
  <div class="overlay" :class="[isShow ? showClass : hideClass]" id="popup-return">
    <div class="popup" style="width: auto">
      <div v-if="this.title!=''" class="popup-head bg-colore-gray">{{ this.title }}</div>
      <div class="popup-body">
        <div class="popup-status" style="padding-top:0px">
          <p class="popup-status-text newline">{{ message }}</p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button class="frm-btn strong large" @click="confirm" :disabled="isOkDisabled" ref="refYesBtn" tabindex="1">
              {{ confirmText }}
            </button>
            <button class="frm-btn large" @click="cancel" @blur="onblur" tabindex="2" v-if="cancelText != ''">
              {{ cancelText }}
            </button>
            <button class="frm-btn large" @click="cancel3" @blur="onblur" tabindex="3" v-if="cancelText3 != ''">
              {{ cancelText3 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "STFMFM02C08ConfirmDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      default: "OK",
    },
    cancelText: {
      type: String,
      default: "キャンセル",
    },
    cancelText3: {
      type: String,
      default: "",
    },
    title:{
      type: String,
      default: "",
    }

  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      isOkDisabled: false,
    };
  },
  computed: {},
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
      this.handleBodyScrollOnModalStateChange(newVal)
    },
  },
  methods: {
    ...mapMutations("businessModule", ["handleBodyScrollOnModalStateChange"]),
    onblur(e){
      if(!e) return;
      e.preventDefault();
      if(e.target.tabIndex==2){
        if(this.cancelText3 ==""){
          this.initFocus();
        }
      }
      else if(e.target.tabIndex==3){
        this.initFocus();
      }
    },
    // **********************************************
    // * confirmダイアログでOKが選択された時の処理
    // **********************************************
    confirm() {
      this.$emit("confirm");
    },
    // **********************************************
    // * confirmダイアログで二つ目のボタンが選択された時の処理
    // **********************************************
    cancel() {
      this.$emit("cancel");
    },
    // **********************************************
    // * confirmダイアログで三つ目のボタンが選択された時の処理
    // **********************************************
    cancel3() {
      this.$emit("cancel3");
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.refYesBtn.focus();
    },
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .popup>.popup-body>.frm-btn-row>.frm-item {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .frm-btn+.frm-btn {
    margin-left: 0px;
  }
}
</style>
